exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/*\r\n  Stylesheet for the page with details on the current business model.\r\n  @author Adrian Rebmann, Steffen Schuhmann, Yannik Sprengart\r\n*/\n.no-link[data-v-706e50fe] {\r\n  text-decoration: none !important;\n}\r\n", "", {"version":3,"sources":["/home/gitlab-runner/builds/b21bf5d0/0/mkz/werner-frontend/src/components/search/businessmodelsearch/detail/businessmodeldetail.css"],"names":[],"mappings":"AAAA;;;EAGE;AAEF;EACE,iCAAiC;CAClC","file":"businessmodeldetail.css","sourcesContent":["/*\r\n  Stylesheet for the page with details on the current business model.\r\n  @author Adrian Rebmann, Steffen Schuhmann, Yannik Sprengart\r\n*/\r\n\r\n.no-link {\r\n  text-decoration: none !important;\r\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-706e50fe","scoped":true,"hasInlineConfig":false}!./src/components/search/businessmodelsearch/detail/businessmodeldetail.css
// module id = OhZ+
// module chunks = 1